export default "__VITE_ASSET__RM3ZDW7o__"